import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import {
  contentPanelFillShellSx,
  contentPanelScrollInnerSx,
  contentPanelScrollSx,
  contentPanelStickyFooterSx,
} from "./contentEditorStyles";

/**
 * Canonical panel body: optional scroll region (contentPanelScrollSx + contentPanelScrollInnerSx)
 * and optional sticky footer. Used by ContentSectionPanel and form layouts with fixed actions.
 */
const ContentPanelScrollLayout = ({ children, footer }) => {
  const scrollArea = (
    <Box sx={contentPanelScrollSx}>
      <Box sx={contentPanelScrollInnerSx}>{children}</Box>
    </Box>
  );

  if (!footer) {
    return scrollArea;
  }

  return (
    <Box sx={contentPanelFillShellSx}>
      {scrollArea}
      <Box sx={contentPanelStickyFooterSx}>{footer}</Box>
    </Box>
  );
};

ContentPanelScrollLayout.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.node,
};

export default ContentPanelScrollLayout;
